import { Column } from 'app/design/primitives/box';
import { Button } from 'app/design/primitives/button';
import { Text } from 'app/design/primitives/text';
import { useTheme } from 'app/shopify';
import { useTranslation } from 'react-i18next';

export function HelpGuestSignUpCta({ onPress }: { onPress: () => void }) {
  const theme = useTheme();
  const { t } = useTranslation('help');

  return (
    <Column
      gap="spacing.general.x2"
      style={{
        backgroundColor: theme.colors['surface.brand.subtle'],
        borderRadius: theme.borderRadii['radius.lg'],
        padding: theme.spacing['spacing.general.x6'],
      }}
    >
      <Text fontSize={20} fontWeight="700" textAlign="center" variant="bodyBase">
        {t('guestCta.title')}
      </Text>
      <Text color="text.secondary" fontSize={15} textAlign="center" variant="bodyBase">
        {t('guestCta.text')}
      </Text>
      <Button marginTop="spacing.general.x2" onPress={onPress} testID="help-guest-signup-button" variant="primary">
        {t('guestCta.button')}
      </Button>
    </Column>
  );
}
